import { TextField, TextFieldProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TextFieldOutlinedBlueFocus = styled((props: TextFieldProps) => (
    <TextField {...props} variant="outlined" />
))(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.custom.customBlue,
            borderWidth: 2,
        },
    },
    '& label': {
        color: theme.palette.custom.customGray,
    },
    '& label.Mui-focused': {
        color: theme.palette.text.primary,
    },
}));